import { Link } from 'react-router-dom';
import CosmicHeroField from '@/components/CosmicHeroField';

/* ─── Illustrative product demo — synthetic data only ──────────────────── */
function ProductDemo() {
  return (
    <div data-testid="product-demo">
      {/* Browser-chrome wrapper */}
      <div className="pub-demo-shell" style={{ maxWidth: '780px', margin: '0 auto' }}>
        <div className="pub-demo-bar">
          <span className="pub-demo-dot" />
          <span className="pub-demo-dot" />
          <span className="pub-demo-dot" />
          <span style={{ flex: 1 }} />
          <span data-testid="demo-synthetic-label" style={{ fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif', fontSize: '10px', color: '#98a2b3', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
            Illustrative demo · Synthetic data
          </span>
        </div>

        <div className="pub-demo-body">
          {/* Finding header */}
          <div className="flex flex-wrap items-start gap-2 mb-3">
            <span
              style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 8px', borderRadius: '3px', fontSize: '11px', fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif', fontWeight: '600', background: '#000', color: '#fff', border: '1px solid #000' }}
            >
              Conflict
            </span>
            <span
              style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 8px', borderRadius: '3px', fontSize: '11px', fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif', fontWeight: '700', background: '#fff', color: '#000', border: '2px solid #000' }}
            >
              ABSTAIN — HUMAN REVIEW REQUIRED
            </span>
            <span style={{ marginLeft: 'auto', fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif', fontSize: '11px', fontWeight: '600', color: '#a3a3a3' }}>
              Pending
            </span>
          </div>

          <h3 style={{ fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif', fontSize: '17px', fontWeight: '700', color: '#000', lineHeight: 1.2, marginBottom: '14px' }}>
            Staff Training Guide contradicts Incident Response Procedure on escalation
          </h3>

          {/* ABSTAIN notice */}
          <div style={{ border: '2px solid #000', borderRadius: '3px', padding: '12px 16px', marginBottom: '18px', background: '#fff' }}>
            <p style={{ fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif', fontSize: '12px', fontWeight: '700', color: '#000', marginBottom: '4px' }}>
              ABSTAIN — HUMAN REVIEW REQUIRED
            </p>
            <p style={{ fontFamily: 'Helvetica, Arial, sans-serif', fontSize: '12px', color: '#667085', lineHeight: 1.5 }}>
              The Brain has identified a direct conflict between two authoritative sources. A named Canon Owner must determine which source takes precedence.
            </p>
          </div>

          {/* Evidence records */}
          <p style={{ fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif', fontSize: '11px', fontWeight: '600', color: '#98a2b3', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '10px' }}>
            Evidence records (2 conflicting)
          </p>
          <div className="space-y-3 mb-5">
            {[
              {
                source: 'Staff Training Guide', version: 'v1.4',
                passage: '"...immediately notify department heads for Tier 1 and Tier 2 incidents."',
              },
              {
                source: 'Incident Response Procedure', version: 'v3.0',
                passage: '"No notification — internal or external — may be issued until containment is verified."',
              },
            ].map(ev => (
              <div key={ev.source} className="pub-demo-evidence-block">
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span style={{ fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif', fontSize: '12px', fontWeight: '600', color: '#000' }}>{ev.source}</span>
                  <span style={{ fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif', fontSize: '11px', color: '#98a2b3' }}>{ev.version}</span>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', marginLeft: 'auto', fontFamily: 'Helvetica, Arial, sans-serif', fontSize: '11px', color: '#667085' }}>
                    <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#000', flexShrink: 0, display: 'inline-block' }} />
                    Conflicting
                  </span>
                </div>
                <p style={{ fontFamily: 'Helvetica, Arial, sans-serif', fontSize: '12px', color: '#444', fontStyle: 'italic', lineHeight: 1.55 }}>
                  {ev.passage}
                </p>
              </div>
            ))}
          </div>

          {/* Footer row */}
          <div className="flex flex-wrap items-center justify-between gap-3" style={{ paddingTop: '14px', borderTop: '1px solid #f0f2f5' }}>
            <div>
              <span style={{ fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif', fontSize: '10px', fontWeight: '600', color: '#98a2b3', textTransform: 'uppercase', letterSpacing: '0.07em' }}>Assigned authority </span>
              <span style={{ fontFamily: 'Helvetica, Arial, sans-serif', fontSize: '13px', color: '#000' }}>Dr. Priya Anand</span>
            </div>
            <span
              style={{ display: 'inline-flex', alignItems: 'center', padding: '6px 14px', background: '#03f37c', borderRadius: '3px', fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif', fontSize: '12px', fontWeight: '600', color: '#000', cursor: 'default' }}
              data-testid="demo-explore-example-btn"
              title="Illustrative example — not a live governed review"
            >
              Explore this example
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─── Landing page ─────────────────────────────────────────────────────── */
export default function Landing() {
  return (
    <div data-testid="landing-page">

      {/* ── HERO ──────────────────────────────────────────────────────── */}
      <section className="pub-section pub-bg-black pub-hero-cosmic" id="hero" style={{ paddingBottom: '80px', minHeight: '560px' }}>
        <CosmicHeroField />
        <div className="pub-hero-cosmic-scrim" aria-hidden="true" />
        <div className="pub-container pub-hero-copy">
          <div className="pub-fade-in" style={{ maxWidth: '860px' }}>
            <h1 className="pub-heading-hero mb-6" data-testid="hero-headline">
              THE SUPERINTELLIGENCE<br />GOVERNOR.
            </h1>
            <p className="pub-body-lg pub-fade-in-2" style={{ color: '#c3c9d4', maxWidth: '560px', marginBottom: '40px' }}>
              KYRDROS keeps institutional knowledge, evidence, and AI-assisted reasoning under accountable human authority—tracking change, surfacing conflict, and grounding every supported answer in its source.
            </p>

            <div className="flex flex-wrap gap-4 pub-fade-in-3">
              <Link to="/enterprise" className="pub-btn-primary pub-btn-primary-lg" data-testid="hero-request-access-btn">
                Request enterprise access
              </Link>
              <a href="#how-it-works" className="pub-btn-ghost pub-btn-ghost-lg pub-btn-ghost-white" data-testid="hero-see-how-btn">
                See how it works
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ── PRODUCT DEMO ──────────────────────────────────────────────── */}
      <section className="pub-section pub-bg-white" id="product">
        <div className="pub-container">
          <div className="mb-10" style={{ maxWidth: '560px' }}>
            <p className="pub-eyebrow mb-3" style={{ color: '#000' }}>Governed intelligence in action</p>
            <h2 className="pub-heading-section" style={{ fontSize: 'clamp(24px, 3vw, 38px)' }}>
              See how conflicting evidence is handled.
            </h2>
            <p className="pub-body mt-4" style={{ color: '#667085' }}>
              When authoritative sources conflict, KYRDROS preserves the evidence, surfaces the disagreement, and supports human review rather than silently deciding what becomes canon.
            </p>
          </div>
          <ProductDemo />
        </div>
      </section>

      {/* ── PROBLEM ───────────────────────────────────────────────────── */}
      <section className="pub-section pub-bg-subtle">
        <div className="pub-container">
          <div style={{ maxWidth: '800px' }}>
            <h2 className="pub-heading-section mb-8">
              Knowledge is easy to collect. Authority is harder to maintain.
            </h2>
            <p className="pub-body-lg" style={{ color: '#444' }}>
              Organizations already have policies, procedures, research, training materials, and AI-generated guidance. The problem is knowing which source controls, whether it is still current, where it conflicts, and who has authority to act.
            </p>
          </div>
        </div>
      </section>

      {/* ── FOUR QUESTIONS ────────────────────────────────────────────── */}
      <section className="pub-section pub-bg-black" id="four-questions">
        <div className="pub-container">
          <h2 className="pub-heading-section pub-heading-section-white mb-12" style={{ maxWidth: '520px' }}>
            Four questions every organization needs to answer.
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="four-questions-grid">
            {[
              {
                q: 'What is authoritative?',
                a: 'Identify the approved source and active version. Know what your organization has formally accepted.',
              },
              {
                q: 'What changed?',
                a: 'Surface material updates, version drift, and stale guidance before it affects decisions.',
              },
              {
                q: 'What conflicts?',
                a: 'Preserve disagreement when evidence does not support one answer. Never collapse a conflict silently.',
              },
              {
                q: 'Who decides?',
                a: 'Route findings to the named human authority. Record the decision, the evidence, and the time.',
              },
            ].map((item, i) => (
              <div key={i} className="pub-q-card" data-testid={`question-card-${i}`}>
                <p className="font-heading font-bold text-white mb-3" style={{ fontSize: '18px', lineHeight: 1.2 }}>
                  {item.q}
                </p>
                <p className="pub-body" style={{ color: '#98a2b3', fontSize: '15px', lineHeight: 1.65 }}>
                  {item.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ──────────────────────────────────────────────── */}
      <section className="pub-section pub-bg-white" id="how-it-works">
        <div className="pub-container">
          <div className="mb-12">
            <p className="pub-eyebrow mb-3" style={{ color: '#000' }}>How it works</p>
            <h2 className="pub-heading-section">One accountable knowledge loop.</h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-testid="how-it-works-steps">
            {[
              {
                n: '01',
                title: 'Connect the sources',
                body: 'Organize the material the institution relies on — policies, procedures, research, and guidance — into a governed register.',
              },
              {
                n: '02',
                title: 'Compare what changed',
                body: 'Detect version drift, conflict between sources, and missing evidence. Surface findings for human review.',
              },
              {
                n: '03',
                title: 'Review the evidence',
                body: 'Give responsible people the exact source passages behind every finding. Nothing is summarized away.',
              },
              {
                n: '04',
                title: 'Record the decision',
                body: 'Preserve the outcome, the authority who made the call, and the time. The audit trail is append-only.',
              },
            ].map((step, i) => (
              <div key={i} data-testid={`step-${i}`} style={{ borderTop: '2px solid #000', paddingTop: '20px' }}>
                <p className="pub-step-number">{step.n}</p>
                <h3 className="font-heading font-bold text-black mb-3" style={{ fontSize: '17px', lineHeight: 1.2 }}>
                  {step.title}
                </h3>
                <p className="pub-body" style={{ color: '#667085', fontSize: '15px', lineHeight: 1.65 }}>
                  {step.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CAPABILITIES ──────────────────────────────────────────────── */}
      <section className="pub-section pub-bg-black" id="capabilities">
        <div className="pub-container">
          <div className="mb-12">
            <p className="pub-eyebrow mb-3">Capabilities</p>
            <h2 className="pub-heading-section pub-heading-section-white" style={{ maxWidth: '520px' }}>
              Five integrated capabilities.
            </h2>
          </div>

          <div data-testid="capabilities-list">
            {[
              {
                name: 'Canon',
                desc: 'Know which sources and versions are approved. Canon is the authoritative register — not a search index.',
              },
              {
                name: 'Brain',
                desc: 'Compare claims, versions, and implications. When sources conflict, the Brain abstains and routes the finding to a human.',
              },
              {
                name: 'Evidence',
                desc: 'Keep findings connected to their support. Every finding is linked to the exact passage and version that created it.',
              },
              {
                name: 'Sentinel',
                desc: 'Detect changes that may require review. Sentinel watches for version updates and routes events to the review queue.',
              },
              {
                name: 'Audit',
                desc: 'Preserve reviews and decisions over time. The audit log is append-only. Events cannot be edited or deleted.',
              },
            ].map(cap => (
              <div key={cap.name} className="pub-cap-item" data-testid={`capability-${cap.name.toLowerCase()}`}>
                <div style={{ minWidth: '130px' }}>
                  <span className="font-heading font-bold text-white" style={{ fontSize: '17px' }}>{cap.name}</span>
                </div>
                <p className="pub-body" style={{ color: '#98a2b3', fontSize: '15px', lineHeight: 1.65 }}>
                  {cap.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── HUMAN AUTHORITY ───────────────────────────────────────────── */}
      <section className="pub-section pub-bg-white">
        <div className="pub-container">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-16 items-center">
            <div>
              <h2 className="pub-heading-section mb-6">
                AI can surface the problem.<br />People retain the authority.
              </h2>
              <p className="pub-body-lg" style={{ color: '#444', maxWidth: '480px' }}>
                KYRDROS is designed to analyze, compare, and recommend. It does not silently rewrite an organization's approved knowledge. Consequential decisions remain with the humans empowered to make them.
              </p>
            </div>
            <div
              style={{ background: '#000', borderRadius: '4px', padding: '40px', display: 'flex', flexDirection: 'column', gap: '16px' }}
              aria-hidden="true"
            >
              {[
                { label: 'Canon Owner', action: 'Approved canon publication', state: 'Current', color: '#03f37c' },
                { label: 'Knowledge Steward', action: 'Escalate recommendation', state: 'Escalated', color: '#fff' },
                { label: 'Compliance Lead', action: 'Approved recommendation', state: 'Approved', color: '#03f37c' },
              ].map(row => (
                <div key={row.label} style={{ borderBottom: '1px solid rgba(255,255,255,0.08)', paddingBottom: '14px', display: 'flex', alignItems: 'start', justifyContent: 'space-between', gap: '12px' }}>
                  <div>
                    <p style={{ fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif', fontSize: '12px', fontWeight: '600', color: '#fff' }}>{row.action}</p>
                    <p style={{ fontFamily: 'Helvetica, Arial, sans-serif', fontSize: '11px', color: '#667085', marginTop: '2px' }}>{row.label}</p>
                  </div>
                  <span style={{ fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif', fontSize: '11px', fontWeight: '700', color: row.color, flexShrink: 0 }}>{row.state}</span>
                </div>
              ))}
              <p style={{ fontFamily: 'Helvetica, Arial, sans-serif', fontSize: '10px', color: 'rgba(255,255,255,0.2)', textAlign: 'center', marginTop: '4px' }}>
                Illustrative — audit log excerpt
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── CUSTOMER PROFILES ─────────────────────────────────────────── */}
      <section className="pub-section pub-bg-subtle">
        <div className="pub-container">
          <h2 className="pub-heading-section mb-12">Built for organizations that cannot afford knowledge drift.</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="customer-profiles">
            {[
              {
                type: 'Business',
                desc: 'Keep policies, procedures, training, and operational guidance aligned. Know which version controls when two documents disagree.',
              },
              {
                type: 'Education',
                desc: 'Govern curriculum, standards, research, and institutional guidance across versions, departments, and time.',
              },
              {
                type: 'Organizations',
                desc: 'Preserve continuity, accountability, and decision authority as knowledge changes, leadership turns over, and systems evolve.',
              },
            ].map(profile => (
              <div
                key={profile.type}
                style={{ background: '#fff', border: '1px solid #d9dee6', borderRadius: '4px', padding: '28px 24px' }}
                data-testid={`profile-${profile.type.toLowerCase()}`}
              >
                <p className="font-heading font-bold text-black mb-3" style={{ fontSize: '18px' }}>{profile.type}</p>
                <p className="pub-body" style={{ color: '#667085', fontSize: '15px', lineHeight: 1.65 }}>{profile.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── TRUST PRINCIPLES ──────────────────────────────────────────── */}
      <section className="pub-section pub-bg-black">
        <div className="pub-container">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-16 items-start">
            <div>
              <h2 className="pub-heading-section pub-heading-section-white" style={{ maxWidth: '400px' }}>
                Four principles that do not bend.
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-8" data-testid="trust-principles">
              {[
                'Evidence stays attached.',
                'Conflicts stay visible.',
                'Decisions stay human.',
                'Each organization stays separate.',
              ].map(p => (
                <div key={p} className="pub-trust-item">
                  <p className="font-heading font-semibold text-white" style={{ fontSize: '16px', lineHeight: 1.3 }}>{p}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── FINAL CTA ─────────────────────────────────────────────────── */}
      <section className="pub-section pub-bg-white">
        <div className="pub-container">
          <div style={{ maxWidth: '640px' }}>
            <h2 className="pub-heading-section mb-5">
              Make organizational knowledge easier to trust.
            </h2>
            <p className="pub-body-lg mb-10" style={{ color: '#667085' }}>
              Talk with Durahuman about a bounded KYRDROS enterprise pilot.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/enterprise" className="pub-btn-primary pub-btn-primary-lg" data-testid="cta-request-access-btn">
                Request enterprise access
              </Link>
              <Link to="/login" className="pub-btn-ghost pub-btn-ghost-lg" data-testid="cta-sign-in-btn">
                Sign in
              </Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
